import { Chip, Stack, Typography } from "@mui/material";
import { motion } from "framer-motion";

interface SectionTitleProps {
  id?: string;
  label?: string;
  title?: string;
  color?: string;
  component?: React.ElementType;
}

const SectionTitle = ({
  id,
  title,
  label,
  component = "h2",
  color = "#EEFF41",
}: SectionTitleProps) => {
  return (
    <>
      <motion.div
        id={id}
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
        style={{ width: "100%" }}
      >
        <Stack
          justifyContent={"start"}
          alignItems={"start"}
          direction={"column"}
          width={"100%"}
          gap={2}
        >
          {label && (
            <Chip
              label={label}
              color="success"
              variant="outlined"
              sx={{
                color: color,
                fontWeight: 500,
                borderColor: color,
                borderRadius: "2px",
                pointerEvents: "none",
                textTransform: "uppercase",
                backgroundColor: `${color}1A`,
              }}
            />
          )}

          <Typography
            variant="xl2"
            lineHeight={1}
            color={color}
            component={component}
            sx={{
              fontSize: {
                xs: "2.6rem",
                sm: "3.5rem",
                md: "4.5rem",
              },
            }}
          >
            {title}
          </Typography>
        </Stack>
      </motion.div>
    </>
  );
};

export default SectionTitle;
